import { notification, Spin, Table } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import InfiniteScroll from "react-infinite-scroll-component";
import { useWorkers } from "context/providers/workers";
import { useSettlement } from "context/providers/settlement";

const IssuesList = () => {
  const { query } = useWorkers();
  const {
    issue_id,
    is_changed,
    has_more_issues,
    data,
    getMoreIssues,
    setIssueId,
    table_columns,
  } = useSettlement();

  return (
    <div id="worker_issues">
      <InfiniteScroll
        key={query}
        dataLength={data?.length || 0}
        next={getMoreIssues}
        hasMore={has_more_issues}
        loader={
          <div style={{ margin: 10, textAlign: "center" }}>
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 28 }} spin />}
            />
          </div>
        }
        scrollableTarget="worker_issues"
      >
        <Table
          rowSelection={{
            selectedRowKeys: [issue_id],
            hideSelectAll: true,
            type: "radio",
          }}
          pagination={false}
          className={is_changed ? "disabled" : ""}
          columns={table_columns}
          rowKey="key"
          dataSource={data?.map((item) => ({
            ...item,
            key: item.id,
            children:
              item.sub_issues?.length > 0
                ? item.sub_issues?.map((child) => ({ ...child, key: child.id }))
                : null,
          }))}
          indentSize={20}
          onRow={({ id }) => ({
            onClick: () => {
              is_changed
                ? notification.warning({
                    message: "UWAGA!",
                    description: "Najpierw zapisz lub odrzuć zmiany!",
                  })
                : setIssueId(id);
            },
          })}
        />
      </InfiniteScroll>
    </div>
  );
};

export default IssuesList;
